import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import GetQuoteForm from "./section-components/get-quote";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const GetQuotePage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Get a Quote" />
      <GetQuoteForm />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default GetQuotePage;
